import script from "./MCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./MCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./MCheckbox.vue?vue&type=style&index=0&id=c3342eaa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3342eaa"]])

export default __exports__